import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { getCurrencySymbol } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { INSPIRATION_CURRENCY } from "web_myplann/Inspiration/Utils/inspirationMoney";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { formatMillions } from "web_myplann/Shared/Utils/formatMillions";
import { getCurrencyLocale } from "web_myplann/Shared/Utils/getCurrencyLocale";

const formatRangeBound = (value: number) =>
	formatMillions(
		value,
		getCurrencyLocale(INSPIRATION_CURRENCY),
		value >= 10_000_000 ? 0 : 1,
	);

export const formatMillionRange = (
	low: number,
	high: number,
	t: TranslateFunction,
) =>
	`${formatRangeBound(low)}–${formatRangeBound(high)} ${t(Resources.Inspiration.OwnHome.millions)} ${getCurrencySymbol(INSPIRATION_CURRENCY)}`;
